export const US_STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const CEILING_TYPES = [
  { value: "vaulted", label: "Vaulted" },
  { value: "cathedral", label: "Cathedral" },
  { value: "tray", label: "Tray" },
  { value: "coffered", label: "Coffered" },
  { value: "exposed-beams", label: "Exposed beams" },
  { value: "tongue-groove", label: "Tongue-and-groove" },
  { value: "acoustic-popcorn", label: "Acoustic popcorn" },
  { value: "smooth-drywall", label: "Smooth drywall" },
];

export const CEILING_HEIGHTS = [
  { value: "standard", label: "Standard (8 ft)" },
  { value: "nine", label: "9 ft" },
  { value: "ten", label: "10 ft" },
  { value: "ten-plus", label: "10 ft+" },
  { value: "volume", label: "Volume / mixed heights" },
];

export const WALL_TYPES = [
  { value: "painted-drywall", label: "Standard painted drywall" },
  { value: "smooth-finish", label: "Smooth finish" },
  { value: "orange-peel", label: "Orange peel" },
  { value: "knockdown", label: "Knockdown" },
  { value: "plaster", label: "Plaster" },
  { value: "venetian-plaster", label: "Venetian plaster" },
  { value: "wood-paneling", label: "Wood paneling" },
  { value: "shiplap", label: "Shiplap" },
  { value: "stone-accent", label: "Stone accent" },
  { value: "brick-accent", label: "Brick accent" },
  { value: "wainscoting", label: "Wainscoting" },
  { value: "crown-molding", label: "Crown molding" },
  { value: "wallpaper", label: "Wallpaper" },
  { value: "textured-feature", label: "Textured feature walls" },
];

export const FLOORING_TYPES = [
  { value: "hardwood", label: "Hardwood" },
  { value: "engineered-wood", label: "Engineered wood" },
  { value: "lvp", label: "LVP (luxury vinyl plank)" },
  { value: "tile", label: "Tile" },
  { value: "travertine", label: "Travertine" },
  { value: "carpet", label: "Carpet" },
  { value: "polished-concrete", label: "Polished concrete" },
  { value: "bamboo", label: "Bamboo" },
  { value: "cork", label: "Cork" },
];

export const ARCHITECTURAL_FEATURES = [
  { value: "arched-doorways", label: "Arched doorways" },
  { value: "built-ins", label: "Built-ins" },
  { value: "niches", label: "Niches" },
  { value: "french-doors", label: "French doors" },
  { value: "pocket-doors", label: "Pocket doors" },
  { value: "barn-doors", label: "Barn doors" },
  { value: "skylights", label: "Skylights" },
  { value: "solar-tubes", label: "Solar tubes" },
  { value: "picture-windows", label: "Picture windows" },
  { value: "bay-windows", label: "Bay windows" },
  { value: "garden-windows", label: "Garden windows" },
];

export const KITCHEN_LAYOUTS = [
  { value: "island", label: "Island" },
  { value: "peninsula", label: "Peninsula" },
  { value: "galley", label: "Galley" },
  { value: "l-shape", label: "L-shape" },
  { value: "u-shape", label: "U-shape" },
  { value: "open", label: "Open to living area" },
];

export const KITCHEN_DETAILS = [
  { value: "walk-in-pantry", label: "Walk-in pantry" },
  { value: "butler-pantry", label: "Butler’s pantry" },
  { value: "pot-filler", label: "Pot filler" },
  { value: "breakfast-nook", label: "Breakfast nook" },
  { value: "desk-nook", label: "Kitchen desk / command center" },
  { value: "prep-sink", label: "Prep sink" },
  { value: "pot-rack", label: "Pot rack / open shelving" },
  { value: "wine-fridge", label: "Wine fridge" },
  { value: "double-oven", label: "Double oven" },
  { value: "gas-range", label: "Gas range" },
  { value: "induction", label: "Induction" },
  { value: "built-in-fridge", label: "Built-in refrigerator" },
  { value: "stainless", label: "Stainless appliances" },
];

export const COUNTERTOP_TYPES = [
  { value: "quartz", label: "Quartz" },
  { value: "granite", label: "Granite" },
  { value: "marble", label: "Marble" },
  { value: "butcher-block", label: "Butcher block" },
  { value: "laminate", label: "Laminate" },
  { value: "concrete", label: "Concrete" },
  { value: "quartzite", label: "Quartzite" },
];

export const CABINET_STYLES = [
  { value: "shaker", label: "Shaker" },
  { value: "flat", label: "Flat / slab" },
  { value: "traditional", label: "Traditional raised panel" },
  { value: "glass", label: "Glass-front" },
  { value: "painted", label: "Painted" },
  { value: "wood", label: "Natural wood" },
];

export const BATHROOM_DETAILS = [
  { value: "walk-in-shower", label: "Walk-in shower" },
  { value: "soaking-tub", label: "Soaking tub" },
  { value: "tub-shower", label: "Tub/shower combo" },
  { value: "double-sinks", label: "Double sinks / dual vanity" },
  { value: "private-toilet", label: "Private toilet room" },
  { value: "storage", label: "Strong bath storage" },
  { value: "tile-surround", label: "Full tile surround" },
  { value: "heated-floors", label: "Heated floors" },
  { value: "frameless-glass", label: "Frameless glass" },
  { value: "make-up-vanity", label: "Makeup vanity" },
];

export const BONUS_ROOMS = [
  { value: "office", label: "Office" },
  { value: "loft", label: "Loft" },
  { value: "gym", label: "Gym / workout" },
  { value: "theater", label: "Theater / media" },
  { value: "guest-suite", label: "Guest suite" },
  { value: "sunroom", label: "Sunroom" },
  { value: "basement", label: "Finished basement" },
  { value: "laundry", label: "Dedicated laundry room" },
  { value: "mudroom", label: "Mudroom" },
  { value: "playroom", label: "Playroom" },
  { value: "wine-cellar", label: "Wine cellar" },
  { value: "adu", label: "ADU / in-law suite" },
];

export const REGIONS = [
  { value: "pacific-northwest", label: "Pacific Northwest" },
  { value: "west-coast", label: "West Coast" },
  { value: "southwest", label: "Southwest" },
  { value: "mountain-west", label: "Mountain West" },
  { value: "midwest", label: "Midwest" },
  { value: "south", label: "South" },
  { value: "mid-atlantic", label: "Mid-Atlantic" },
  { value: "northeast", label: "Northeast" },
  { value: "alaska-hawaii", label: "Alaska / Hawaii" },
  { value: "flexible", label: "Flexible / open" },
];
